// src/components/Modals/NotificationConfirmationModal.js
import React, { memo } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import styles from "../../styles/NotificationModal.module.css";
import "../../styles/ModalShared.css";
const NotificationConfirmationModalComponent = ({
    isOpen,
    toggle,
    onConfirm,
    title,
    message,
    confirmText = "Yes",
    loading = false,
}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} zIndex={9999999} centered className={`custom-modal ${styles.modal}`}>
            {/* Loading indicator */}
            {loading && (
              <div className={`loading-bar ${styles.loadingBar}`}>
                <div className={`loading-bar-inner ${styles.loadingBarInner}`} />
              </div>
            )}
            {/* Close Icon */}
            <button className={styles.closeBtn} onClick={toggle} aria-label="Close">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                >
                    <path
                        d="M13 1L1 13M1 1L13 13"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
            <ModalBody className={styles.body}>
                <div className={styles.header}>
                    <h5 className={styles.title}>{title}</h5>
                    <p className={styles.message}>{message}</p>
                </div>
            </ModalBody>
            <div className={styles.footer}>
                <button className={styles.btnCancel} onClick={toggle}>
                    Cancel
                </button>
                <button className={styles.btnConfirm} onClick={onConfirm}>
                    {confirmText}
                </button>
            </div>
        </Modal>
    );
};
NotificationConfirmationModalComponent.displayName = "NotificationConfirmationModal";

const NotificationConfirmationModal = memo(NotificationConfirmationModalComponent);

NotificationConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmText: PropTypes.string,
  loading: PropTypes.bool,
};

export default NotificationConfirmationModal;
